export const buildNumber = '20260402.5';
export const version = '3.12.3';
export const latestCommit = '02b68018fc15a36f46897f4eec213fe636516ee8';
